import React, { useEffect, useState } from "react";
import visionImg from "../../Assert/Vision image/v4.webp";
import visionImg2 from "../../Assert/Vision image/v3.webp";
import visionImg3 from "../../Assert/Vision image/v2.webp";
import visionImg4 from "../../Assert/Vision image/v1.webp";

const VisionSection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Data for sections with layout type
  const sections = [
    {
      id: 1,
      title: "Vision",
      description: "To provide quality services that exceed the expectations of our esteemed customers.",
      image: visionImg,
      layout: "image-left" // Image → Arrow → Divider → Content
    },
    {
      id: 2,
      title: "Mission",
      description: "To build long-term relationships with our customers and provide exceptional customer service.",
      image: visionImg2,
      layout: "content-left" // Content ← Arrow ← Divider ← Image
    },
    {
      id: 3,
      title: "Values",
      description: "Integrity, excellence, innovation, and teamwork at the core of everything we do.",
      image: visionImg3,
      layout: "image-left" // Image → Arrow → Divider → Content
    },
    {
      id: 4,
      title: "Strategy",
      description: "Leveraging cutting-edge technology to deliver sustainable solutions for our clients.",
      image: visionImg4,
      layout: "content-left" // Content ← Arrow ← Divider ← Image
    }
  ];

  // Render section based on layout type
  const renderSection = (section) => {
    const isImageLeft = section.layout === "image-left";
    
    // For mobile: always stack image first, then content
    if (isMobile) {
      return (
        <div
          key={section.id}
          style={{
            maxWidth: "1200px",
            margin: "0 auto 80px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* IMAGE */}
          <div style={{ width: "100%" }}>
            <img
              src={section.image}
              alt={section.title}
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "22px",
                clipPath: "polygon(20% 0%, 80% 0%, 100% 20%, 90% 80%, 70% 100%, 20% 90%, 0% 70%, 0% 20%)",
              }}
            />
          </div>

          {/* CONTENT */}
          <div
            style={{
              margin: "40px 0 0 0",
              width: "100%",
              textAlign: "center",
            }}
          >
            <h2 style={{ fontSize: "42px", fontWeight: "700", marginBottom: "16px", color: "#111" }}>
              {section.title}
            </h2>
            <p style={{ fontSize: "18px", lineHeight: "1.7", color: "#333", maxWidth: "520px", margin: "0 auto" }}>
              {section.description}
            </p>
          </div>
        </div>
      );
    }

    // For desktop: alternate layouts
    return (
      <div
        key={section.id}
        style={{
          maxWidth: "1200px",
          margin: "0 auto 80px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* IMAGE LEFT LAYOUT: [Image] → [Arrow] → [Divider] → [Content] */}
        {isImageLeft ? (
          <>
            {/* IMAGE */}
            <div style={{ width: "45%" }}>
              <img
                src={section.image}
                alt={section.title}
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "22px",
                  clipPath: "polygon(20% 0%, 80% 0%, 100% 20%, 90% 80%, 70% 100%, 20% 90%, 0% 70%, 0% 20%)",
                }}
              />
            </div>

         
            {/* DIVIDER */}
            <div style={{ width: "2px", height: "140px", backgroundColor: "#000" }} />

            {/* ARROW (points right) */}
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "30px" ,marginLeft:"-55px"}}>
              <div
                style={{
                  width: 0,
                  height: 0,
                  borderTop: "14px solid transparent",
                  borderBottom: "14px solid transparent",
                  borderLeft: "18px solid #000",
                }}
              />
            </div>

            {/* CONTENT */}
            <div style={{ width: "45%", textAlign: "left" }}>
              <h2 style={{ fontSize: "42px", fontWeight: "700", marginBottom: "16px", color: "#111" }}>
                {section.title}
              </h2>
              <p style={{ fontSize: "18px", lineHeight: "1.7", color: "#333", maxWidth: "520px" }}>
                {section.description}
              </p>
            </div>
          </>
        ) : (
          /* CONTENT LEFT LAYOUT: [Content] ← [Arrow] ← [Divider] ← [Image] */
          <>
            {/* CONTENT */}
            <div style={{ width: "45%", textAlign: "right" }}>
              <h2 style={{ fontSize: "42px", fontWeight: "700", marginBottom: "16px", color: "#111" }}>
                {section.title}
              </h2>
              <p style={{ fontSize: "18px", lineHeight: "1.7", color: "#333", maxWidth: "520px", marginLeft: "auto" }}>
                {section.description}
              </p>
            </div>

            {/* ARROW (points left) */}
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "30px"  ,marginRight:"-55px"}}>
              <div
                style={{
                  width: 0,
                  height: 0,
                  borderTop: "14px solid transparent",
                  borderBottom: "14px solid transparent",
                  borderRight: "18px solid #000",
                }}
              />
            </div>

            {/* DIVIDER */}
            <div style={{ width: "2px", height: "140px", backgroundColor: "#000" }} />

            {/* ARROW (points left) */}


            {/* IMAGE */}
            <div style={{ width: "45%" }}>
              <img
                src={section.image}
                alt={section.title}
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "22px",
                  clipPath: "polygon(20% 0%, 80% 0%, 100% 20%, 90% 80%, 70% 100%, 20% 90%, 0% 70%, 0% 20%)",
                }}
              />
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <section style={{ padding: "80px 20px", backgroundColor: "#fff" }}>
      {sections.map((section) => renderSection(section))}
    </section>
  );
};

export default VisionSection;